// extracted by mini-css-extract-plugin
export var layoutContainer = "_d4-0";
export var layoutContainerNoRounding = "_d4-6";
export var layoutContainerOpen = "_d4-5";
export var layoutContainerResizing = "_d4-1";
export var mainContent = "_d4-2";
export var resizeDivider = "_d4-3";
export var slidePanel = "_d4-4";